import { useState } from "react";
import { cn } from "@/lib/utils";

/** Opis prijave; dugački se skraćuje na četiri reda uz „Prikaži cijeli opis“. */
export function Description({
  text,
  dimmed = false,
  collapsible = true,
}: {
  text: string;
  dimmed?: boolean;
  collapsible?: boolean;
}) {
  const [expanded, setExpanded] = useState(false);
  const long = collapsible && (text.length > 320 || text.split("\n").length > 5);

  return (
    <div className="space-y-1">
      <p
        className={cn(
          "max-w-[75ch] whitespace-pre-wrap break-words text-[13px] leading-relaxed",
          dimmed && "text-muted-foreground",
          long && !expanded && "line-clamp-4",
        )}
      >
        {text}
      </p>
      {long && (
        <button
          type="button"
          onClick={() => setExpanded((v) => !v)}
          aria-expanded={expanded}
          className="text-[11px] text-muted-foreground underline underline-offset-2 outline-none hover:text-foreground focus-visible:ring-[3px] focus-visible:ring-ring/50"
        >
          {expanded ? "Prikaži manje" : "Prikaži cijeli opis"}
        </button>
      )}
    </div>
  );
}
